import { Link } from "@tanstack/react-router";
import { Rocket } from "lucide-react";

export function SiteHeader({ showAbout = false, hideBookCall = false, disableLogoLink = false }: { showAbout?: boolean; hideBookCall?: boolean; disableLogoLink?: boolean } = {}) {
  return (
    <header className="border-b border-border bg-background/95 backdrop-blur sticky top-0 z-40">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        {disableLogoLink ? (
          <div className="flex items-center gap-2 font-semibold text-foreground">
            <Rocket className="h-5 w-5 text-primary" aria-hidden="true" />
            <span>Three Day Launch<sup className="text-[0.6em] ml-0.5">®</sup></span>
          </div>
        ) : (
          <Link to="/" className="flex items-center gap-2 font-semibold text-foreground">
            <Rocket className="h-5 w-5 text-primary" aria-hidden="true" />
            <span>Three Day Launch<sup className="text-[0.6em] ml-0.5">®</sup></span>
          </Link>
        )}
        <ul className="hidden items-center gap-6 md:flex">
          <li>
            <a href="/#how" className="text-sm uppercase text-muted-foreground hover:text-foreground">
              How it works
            </a>
          </li>
          <li>
            <a href="/#faq" className="text-sm uppercase text-muted-foreground hover:text-foreground">
              FAQ
            </a>
          </li>
          <li>
            <Link to="/blog" className="text-sm uppercase text-muted-foreground hover:text-foreground">
              Blog
            </Link>
          </li>
          <li>
            <a href="/#free-tool" className="text-sm uppercase text-muted-foreground hover:text-foreground">
              Free Tool
            </a>
          </li>
          {showAbout && (
            <li>
              <Link to="/about" className="text-sm uppercase text-muted-foreground hover:text-foreground">
                About
              </Link>
            </li>
          )}
          <li>
            <Link to="/contact" className="text-sm uppercase text-muted-foreground hover:text-foreground">
              Contact
            </Link>
          </li>
          {!hideBookCall && (
            <li>
              <a
                href="/book"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center rounded-lg bg-primary-gradient px-4 py-2 text-sm font-semibold uppercase text-primary-foreground shadow hover:opacity-90 transition"
              >
                Book A Free Call
              </a>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
}

export function SiteFooter({ hideMenu = false }: { hideMenu?: boolean } = {}) {
  return (
    <footer className="bg-secondary text-secondary-foreground border-t border-white/10 py-10 mt-[0px]">
      <div className="mx-auto max-w-7xl px-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-primary-gradient flex items-center justify-center">
            <Rocket className="h-4 w-4 text-white" />
          </div>
          <span className="font-bold">Three Day Launch<sup className="text-[0.6em] ml-0.5">®</sup></span>
        </div>
        {!hideMenu && (
          <nav className="flex items-center gap-6 text-sm text-white/70">
            <Link to="/blog" className="hover:text-white transition-colors">Blog</Link>
            <Link to="/about" className="hover:text-white transition-colors">About</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
          </nav>
        )}
        <div className="text-sm text-white/80">© {new Date().getFullYear()} Three Day Launch. Custom Websites.</div>
      </div>
      <div className="mx-auto max-w-7xl px-6 mt-4 text-center text-sm text-white/80">
        Based in Chicago | Serving Clients Worldwide
      </div>
      <div className="mx-auto max-w-7xl px-6 mt-2 text-center text-xs text-white/60">
        Three Day Launch is an independent website design studio creating professional websites.
      </div>
    </footer>
  );
}
